import React, { useState, useEffect } from 'react';
import './Footer.css';
import W3C from './../../assets/vcss.png';
import WCAG from './../../assets/wcag2AA.png';
import XHTML from './../../assets/valid-xhtml10.png';
import { FaArrowUp } from "react-icons/fa6";
import { Link } from 'react-router-dom';
const Footer = () => {
    const [isVisible, setIsVisible] = useState(false);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };
    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 200) {  
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
        };

        window.addEventListener('scroll', handleScroll);

        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <footer className="footer ">
            <div className="footer-links">
                <Link to={"/"}>Home</Link>
                <span>|</span>
                <Link to={"/photo-gallery"}>Photo Gallery</Link>
                <span>|</span>
                <Link to={"/accessibility-statement"}>Accessibility Statement</Link>
                <span>|</span>
                <Link to={"/website-policies"}>Website Policies</Link>
                <span>|</span>
                <Link to={"/terms-and-conditions"}>Terms & Conditions</Link>
                <span>|</span>
                <Link to={"/disclaimer"}>Disclaimer</Link>
                <span>|</span>
                <Link to={"/feedback"}>Feedback</Link>
                <span>|</span>
                <Link to={"/help"}>Help</Link>
                <span>|</span>
                <Link to={"/sitemap"}>Sitemap</Link>
                <span>|</span>
                <Link to={"/contact-us"}>Contact Us</Link>
            </div>
            <div className="footer-copyright">
                <p>
                    Copyright © 2017. Haryana Seeds Development Corporation Ltd., Government of Haryana. All Rights Reserved.
                </p>
                <p>
                <strong>No. Of Visitors: </strong>   <a href="https://www.coolseotools.com/website-visitor-counter" target="_blank" title="Web Counter">
<img src="https://www.coolseotools.com/website-visitor-counter/count/&style=style7&show=p&num=8&uid=bhI"  title="Web Counter" alt="AtoZSEOTools Web Counter" />
</a> Page last updated on: 11/04/2025
                  
                </p>
            </div>
            <div className="footer-icons">
                <img src={W3C} alt="W3C" />
                <img src={WCAG} alt="WCAG" />
                <img src={XHTML} alt="XHTML" />
            </div>
           
            {isVisible && (
                <button className="scroll-to-top" onClick={scrollToTop}>
                    <FaArrowUp  />{" "}
                </button>
            )}
        </footer>
    );
};

export default Footer;
